module.exports = __webpack_public_path__ + "static/media/chip2.251cc401.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bcase/assets/chip2.png
// module id = 2563
// module chunks = 0